import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

export default function Imprint() {
    return (
        <Container className="py-5">
            <Row className="my-3">
                <Col>
                    <p className="font-weight-bold">Gartenbau Henkel GmbH</p>
                    <p>Alte Bayernwerkstraße 277</p>
                    <p>85757 Karlsfeld</p>
                </Col>

            </Row>
            <Row className="my-3">
                <Col>
                    <p>mobil: +49 (0) 171 2845843</p>
                    <p>Büro: +49 (0) 8131 6150030</p>
                    <p>mail@gartenbau-henkel.de</p>
                </Col>
            </Row>
            <Row className="my-3">

                <Col>
                    <p>Geschäftsführer: Maximilian Henkel</p>
                    <p>Gerichtsstand: München, HRB 257282</p>
                    <p>Steuernummer: 115/127/00375</p>
                </Col>
            </Row>
        </Container>
    )
}
